import type { BlockDefinition, ParagraphProps } from '../types';
import { escapeHtml } from '../html';

export const paragraph: BlockDefinition<ParagraphProps> = {
  type: 'paragraph',
  meta: {
    label: 'Paragraph',
    icon: '📝',
    category: 'content',
    description: 'Body text. Use for bios and descriptions.',
  },
  defaults: () => ({
    text: 'A short bio about you or your project.',
    align: 'center',
  }),
  validate(input) {
    const i = (input ?? {}) as Partial<ParagraphProps>;
    return {
      text: typeof i.text === 'string' ? i.text.slice(0, 800) : '',
      align: ['left', 'center', 'right'].includes(i.align as string)
        ? (i.align as ParagraphProps['align'])
        : 'center',
    };
  },
  render(props) {
    // Preserve newlines as <br>. Otherwise everything's plain text — no
    // markdown for now (Phase B adds it).
    const escaped = escapeHtml(props.text).replace(/\n/g, '<br>');
    return `<div class="pb-block pb-paragraph" style="text-align:${props.align};">
  <p style="font-size:16px;line-height:1.5;color:var(--text);opacity:0.85;margin:0;">${escaped}</p>
</div>`;
  },
};
